import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState } from "react";

export default function CompaniesCarrousel() {
  const [companies, setCompanies] = useState<any[]>([]);

  useEffect(() => {
    ApiRequest({
      url: '/companies/carouselList',
      method: 'GET',
      setResponse: (response: any) => {
        if (response.status === 'success') {
          setCompanies(response.list);
        }
      }
    });
  }, []);

  if (!companies.length) return <div style={{ height: 180 }} />;

  const isSingle = companies.length === 1;
  // Duplicate enough times so the track is always wide (seamless loop)
  const reps = companies.length < 4 ? 4 : 2;
  const track = Array(reps).fill(companies).flat();

  return (
    <section style={{
      padding: '52px 0',
      background: '#f8fafd',
      borderTop: '1px solid #e8edf4',
      borderBottom: '1px solid #e8edf4',
      overflow: 'hidden',
    }}>
      <h2 style={{
        textAlign: 'center',
        fontSize: 21,
        fontWeight: 700,
        color: '#135095',
        marginBottom: 4,
        letterSpacing: '-0.3px',
      }}>
        Marcas Asociadas
      </h2>
      <p style={{
        textAlign: 'center',
        color: '#94a3b8',
        fontSize: 13,
        marginBottom: 36,
        marginTop: 0,
      }}>
        Empresas que confían en nuestra comunidad de profesionales
      </p>

      {/* Scrolling track */}
      <div style={{ overflow: isSingle ? 'visible' : 'hidden', width: '100%', display: isSingle ? 'flex' : 'block', justifyContent: 'center' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isSingle ? 'center' : undefined,
            gap: 64,
            width: isSingle ? 'auto' : 'max-content',
            animation: isSingle ? 'none' : 'marqueeScroll 28s linear infinite',
          }}
          onMouseEnter={e => { if (!isSingle) (e.currentTarget as HTMLDivElement).style.animationPlayState = 'paused'; }}
          onMouseLeave={e => { if (!isSingle) (e.currentTarget as HTMLDivElement).style.animationPlayState = 'running'; }}
        >
          {(isSingle ? companies : track).map((c: any, i: number) => {
            const img = (
              <img
                src={c.logo}
                alt={c.name}
                style={{
                  height: 90,
                  maxWidth: 220,
                  objectFit: 'contain',
                  filter: 'grayscale(25%) opacity(0.85)',
                  transition: 'filter 0.2s',
                  display: 'block',
                  flexShrink: 0,
                }}
                onMouseEnter={e => { (e.currentTarget as HTMLImageElement).style.filter = 'grayscale(0%) opacity(1)'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLImageElement).style.filter = 'grayscale(25%) opacity(0.85)'; }}
              />
            );

            return c.website_url ? (
              <a
                key={`${c.company_id}-${i}`}
                href={c.website_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}
              >
                {img}
              </a>
            ) : (
              <div key={`${c.company_id}-${i}`} style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                {img}
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes marqueeScroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
